import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent, Button } from '@mui/material';
import { REPORT_STATUS } from '../const/config'
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { fetchData } from '../func/api';
import { BaseDialog } from '../components/base_dialog';
import SkeletonLoading from "../components/skeleton_loading";
import { postData } from "../func/api";
import Alert from "@mui/material/Alert";
import Snackbar from '@mui/material/Snackbar';
import { ROLE_UUID } from '../const/config';

// コンテンツとスタイルの記述を分けることでコンポーネント部分の可読性を向上させる
// スタイルを一元管理することで保守性を向上する
const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100dvh - 120px)', // ビューポートの高さいっぱいからヘッダーフッター分を差し引く
        backgroundColor: '#f5f5f5',
        p: 2 // スマホでも適切な余白を確保
    },
    card: {
        width: { xs: '90%', sm: '70%', md: '50%' },
        maxWidth: '600px',
        minHeight: '200px',
        p: 4,
        boxShadow: 3,
        borderRadius: 2
    },
    cardTitle: {
        fontSize: { xs: '1.2rem', sm: '1.5rem' }
    },
    cardContent: {
        mb: 3,
        fontSize: { xs: '0.9rem', sm: '1rem' }
    },
    cardButton: {
        width: { xs: '100%', sm: '80%' },
        mt: '5%'
    }
}


const EarthquakeRegister = (props) => {
    // URLからuuidを取得
    const [earthquake, setEarthquake] = useState(null);
    const [dialogMessage, setDialogMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertSeverity, setAlertSeverity] = useState("");

    const [open, setOpen] = useState(false);


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFirstReportQuick = async () => {
        if (isViewer) {
            window.location.href = `/earthquake_list`;
            return;
        }

        if (!earthquake) {
            try {
                const response = await postData(`api/register_earthquake`, {});
                if (response) {
                    window.location.href = `/earthquake_detail/${response.earthquake_uuid}`;
                } else {
                    setOpen(false);
                    setAlertMessage("地震対応業務の開始に失敗しました。時間をおいて再度お試しください。");
                    setAlertOpen(true);
                    setAlertSeverity("error");
                }
            } catch (error) {
                setOpen(false);
                setAlertMessage("地震対応業務の開始に失敗しました。時間をおいて再度お試しください。");
                setAlertOpen(true);
                setAlertSeverity("error");
            }
        } else {
            window.location.href = `/earthquake_list`;
        }
    }

    useEffect(() => {
        const fetchDataSequentially = async () => {
            setLoading(true);
            try {
                // 地震データを取得
                const earthquakeData = await fetchData(`api/get_earthquake_list/`);
                const reportingData = earthquakeData.find(obj =>
                    obj.report_status_uuid === REPORT_STATUS.UNSUPPORTED ||
                    obj.report_status_uuid === REPORT_STATUS.FISRTREPORT ||
                    obj.report_status_uuid === REPORT_STATUS.PRIMARYCHECK ||
                    obj.report_powerplant_status_uuid === REPORT_STATUS.POWERPLANTSUPPORT
                );
                setEarthquake(reportingData)
                if (reportingData) {
                    setDialogMessage(`地震一覧に遷移します。 よろしいですか？`)
                } else {
                    setDialogMessage(`地震対応業務を開始します。 よろしいですか？`)
                }
            } catch (error) {
                console.error("データ取得中にエラーが発生しました:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchDataSequentially();

    }, []);

    if (loading) {
        return <SkeletonLoading />;
    }

    const isViewer = currentUser?.role_id === ROLE_UUID.VIEWER;

    // ページ内で使われるテキストを変数化
    const pageTexts = {
        cardTitle: isViewer
            ? "報告状況を確認してください"
            : earthquake
                ? "報告状況を確認してください"
                : "地震対応を開始してください",
        cardContent: isViewer
            ? "閲覧権限のユーザーは地震対応を開始できません。\n「地震一覧ボタン」をクリックして報告状況を確認してください。"
            : earthquake
                ? "報告業務を実施中です。\n「地震一覧ボタン」をクリックして報告状況を確認してください。"
                : "「地震対応を開始する」ボタンををクリックし地震対応業務を開始してください。",
        cardButton: isViewer
            ? "地震一覧"
            : earthquake
                ? "地震一覧"
                : "地震対応を開始する",
        dialogContent: isViewer
            ? "地震一覧に遷移します。\n よろしいですか？"
            : earthquake
                ? "地震一覧に遷移します。\n よろしいですか？"
                : "地震対応業務を開始します。\n よろしいですか？",
    };

    return (
        <>
            <Box sx={styles.container} >
                <Card sx={styles.card}>
                    <CardContent>
                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            sx={{ ...styles.cardTitle, whiteSpace: 'pre-line' }} // スマホ・タブレット対応
                            gutterBottom
                        >
                            {pageTexts.cardTitle}
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{ ...styles.cardContent, whiteSpace: 'pre-line' }} // スマホでも適切な文字サイズに
                        >
                            {pageTexts.cardContent}
                        </Typography>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={handleClickOpen}
                                sx={styles.cardButton} // スマホではボタンを横いっぱいに
                            >
                                {pageTexts.cardButton}
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>

            <BaseDialog
                open={open}
                onClose={handleClose}
                title={null}
                message={pageTexts.dialogContent}
                onConfirm={handleFirstReportQuick}
                confirmText='OK'
                cancelText='キャンセル'
            />

            <Snackbar
                open={alertOpen}
                autoHideDuration={3000}
                onClose={() => setAlertOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert severity={alertSeverity} onClose={() => setAlertOpen(false)}>
                    {alertMessage}
                </Alert>
            </Snackbar>
        </>
    )
}
export default EarthquakeRegister;